<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"display: flex; justify-content: center; align-items: center; text-align: center; padding: 14px 20px; border: 1px solid #313585; border-radius: 12px; background: #313585;"' class="container " >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='"text-align: center; font-weight: 700; font-size: 1.5rem; margin: 0; color: #fff;"' class="" >
                <template #default>دوره های آموزشی   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"border-radius: 16px; overflow: hidden;\nmargin-top: 40px;"' class="mb-5 bg-secondary shadow container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container  mt-4  py-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"\n\n"' class="row text-center p-0  align-items-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 " >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"font-size:39px;"' class="text-white font-weight-bold" >
                <template #default>دوره ها   </template>
                </m-h1></template>
                </m-div><m-product-slider-1 v-bind='{...{"offerType":"number","offerStatus":true,"title":"","productCategories":["\u062f\u0648\u0631\u0647"],"productBrands":null,"waitForCategory":false,"waitForBrand":false,"categoryColumn":"slug","brandColumn":"slug","productCardLink":false,"productCardLinkTarget":"_self","activeLatestFilter":false,"activeCategoryFilter":true,"productCardName":"mProductCard207","showKeywords":true,"showDefaultSlideItem":false,"swiperPerViewSM":2,"swiperPerViewMD":2,"swiperPerViewLG":3,"autoPlay":false,"autoPlayDuration":1000,"productStoresDirectFilter":0,"productStoresDirectFilterColumn":"id","slicer":12},...{}}' :style='"border: none;\n"' class="img-slider-400 col-lg-9 py-1" >
                <template #default>   </template>
                </m-product-slider-1></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mProductSlider1 from '@moeinmdn/miw-alpha-components/src/package/Product/ProductSlider/ProductSlider1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mP,mH1,mProductSlider1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
